import Vue from "vue";
import VueRouter from "vue-router";

// top
import Home from "@/components/page/home/App.vue";

// 各固定ページ
import Concept from "@/components/page/fixed_page/App.vue";
import Service from "@/components/page/fixed_page/App.vue";
import Catalog from "@/components/page/fixed_page/App.vue";
import Information from "@/components/page/fixed_page/App.vue";
import Voice from "@/components/page/fixed_page/App.vue";
import Calendar from "@/components/page/fixed_page/App.vue";
import Access from "@/components/page/fixed_page/App.vue";
import Faq from "@/components/page/fixed_page/App.vue";
import Download from "@/components/page/fixed_page/App.vue";
import Recruit from "@/components/page/fixed_page/App.vue";
import Privacypolicy from "@/components/page/fixed_page/App.vue";

// coupon
import Coupon from "@/components/page/coupon/App.vue";

// news
import NewsList from "@/components/page/news/list/App.vue";
import NewsDetail from "@/components/page/news/detail/App.vue";

// research
import Research from "@/components/page/research/App.vue";

// contact
import Contact from "@/components/page/contact/App.vue";

// 404エラー
import NotFound from "@/components/system/Page404.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        component: Home,
        meta: {
            title: "cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },
    {
        path: "/concept",
        component: Concept,
        meta: {
            title: "X'mas | cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },
    {
        path: "/service",
        component: Service,
        meta: {
            title: "INFORMATION | cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },
    {
        path: "/catalog",
        component: Catalog,
        meta: {
            title: "DECORATION | cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },
    {
        path: "/information",
        component: Information,
        meta: {
            title: "SEASONAL | cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },
    {
        path: "/voice",
        component: Voice,
        meta: {
            title: "STANDARD | cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },
    {
        path: "/calendar",
        component: Calendar,
        meta: {
            title: "CALENDAR | cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },
    {
        path: "/access",
        component: Access,
        meta: {
            title: "ACCESS | cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },
    {
        path: "/faq",
        component: Faq,
        meta: {
            title: "BAKES&GIFT | cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },
    {
        path: "/download",
        component: Download,
        meta: {
            title: "DOWNLOAD | cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },
    {
        path: "/recruit",
        component: Recruit,
        meta: {
            title: "cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },
    {
        path: "/privacypolicy",
        component: Privacypolicy,
        meta: {
            title: "PRIVACYPOLICY | cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },

    {
        path: "/coupon",
        component: Coupon,
        meta: {
            title: "cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },

    {
        path: "/news",
        component: NewsList,
        meta: {
            title: "NEWS | cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },
    {
        path: "/news/:id",
        component: NewsDetail,
        meta: {
            title: "NEWS | cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },

    {
        path: "/research",
        component: Research,
        meta: {
            title: "cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },

    {
        path: "/contact",
        component: Contact,
        meta: {
            title: "お問い合わせ | cake&cafeGRüN（ぐりゅーん）|甘さ控え目でシンプルに。仙台市若林区の洋菓子店",
        },
    },

    {
        path: "*",
        name: "NotFound",
        component: NotFound,
    },
];

const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

export default router;
